import type {
    SiteAnalyticsDataRequest,
    SiteAnalyticsDataResult,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-scaffold.type';
import type {
    SiteAnalyticsPageDefinition,
    SiteAnalyticsPageDefinitionDeps,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-definition.type';
import {
    buildEventsScaffoldConfig,
    loadEventsTabData,
} from '@client/app/feature-modules/site-analytics/definitions/events-definition.utils';

const EVENTS_ACTIONS_CONFIG = buildEventsScaffoldConfig({
    tableKey: 'site-analytics-events-actions',
    dataSource: 'eventsActions',
    exportCategory: 'event_actions',
    tableCaptionKey: 'siteAnalytics.events.actions.table.caption',
    primaryColumnHeaderKey: 'siteAnalytics.events.table.column.action',
    secondaryColumnHeaderKey: 'siteAnalytics.events.table.column.name',
    primarySortField: 'event_action',
});

const loadEventsActionsData = (
    request: SiteAnalyticsDataRequest,
    deps: SiteAnalyticsPageDefinitionDeps,
): Promise<SiteAnalyticsDataResult> => {
    return loadEventsTabData(
        request,
        deps,
        (domainId, params) => deps.statisticsEventsRepoService.getEventsActions(domainId, params),
        'event_names',
    );
};

export const EVENTS_ACTIONS_DEFINITION: SiteAnalyticsPageDefinition = {
    key: 'eventsActions',
    config: EVENTS_ACTIONS_CONFIG,
    loadData: loadEventsActionsData,
};

export const EVENTS_ACTIONS_PAGE_CONFIG = EVENTS_ACTIONS_DEFINITION.config;
